import { TableHead, TableRow } from '@mui/material'
import { flexRender } from '@tanstack/react-table'
import React from 'react'
import CoreTableCell from './CoreTableCell'
// import PropTypes from 'prop-types'

const CoreTableHead = ({ table }) => {
	return (
		<TableHead>
			{table.getHeaderGroups().map(headerGroup => (
				<TableRow key={headerGroup.id}>
					{headerGroup.headers.map(header => {
						return (
							<CoreTableCell key={header.id}>
								{header.isPlaceholder
									? null
									: flexRender(header.column.columnDef.header, header.getContext())}
							</CoreTableCell>
						)
					})}
				</TableRow>
			))}
		</TableHead>
	)
}

// CoreTableHead.defaultProps = {}

// CoreTableHead.propTypes = {}

export default React.memo(CoreTableHead)
